/**
 * @desc getClientListByUserCode
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(
  params: API.ucenter.userFacadeImpl.getClientListByUserCode.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/client/clienListtByUserCode`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
